const React = require('react');
const { createElement: h } = React;
const VariableAutocompleteInput = require('./VariableAutocompleteInput');

// Sidebar editor for the Set Variable node. Mirrors the cramped inline editor
// (SetVariableEditor in WorkflowNode.js) but laid out as a proper labeled form
// so it has room to breathe in the wider sidebar:
//
//   Variable
//   [ dropdown of variable names                        v ]
//
//   Source
//   [ Manual ] [ From input ]
//
//   Value (when source=Manual)
//   [ multi-line textarea, supports @variable references     ]
//
// Variable autocomplete on the value field happens via the chip editor in the
// inline tile. In the sidebar we keep things simple — a plain textarea where
// the user types @VarName references manually.
function SetVariableSidebarEditor(props) {
  var paramValues = props.paramValues || {};
  var onParamChange = props.onParamChange || function() {};
  var variableNodes = props.variableNodes || [];

  var selectedVar = String(paramValues.variable || '');
  var isFromInput = String(paramValues.source || 'false') === 'true';
  var selectedMode = String(paramValues.mode || 'replace').toLowerCase();
  var manualValue = paramValues.value !== undefined && paramValues.value !== null
    ? String(paramValues.value)
    : '';

  // Mode options surfaced in the UI. Replace = overwrite (default, today's behavior).
  // Append = push onto a list / concat a string. Merge = Object.assign for an object.
  var modeOptions = [
    { value: 'replace', label: 'Replace', hint: 'overwrite the variable' },
    { value: 'append', label: 'Append', hint: 'add to a list (or concat a string)' },
    { value: 'merge', label: 'Merge', hint: 'merge fields into an object' }
  ];
  var selectedModeHint = (modeOptions.find(function(o) { return o.value === selectedMode; }) || modeOptions[0]).hint;

  // Dedup variable names by id-keyed map (multiple Variable nodes can share a
  // display title; we still want unique select options). buildEditorContextNodes
  // bundles predecessor output nodes alongside real variables for the value-field
  // @-autocomplete — exclude those here, the Set Variable target dropdown must
  // only list actual variables, not arbitrary upstream nodes.
  var seen = {};
  var options = [];
  variableNodes.forEach(function(vn) {
    if (!vn || vn._isNodeOutput) return;
    if (vn.icon && vn.icon !== 'variables') return;
    var name = String(vn.title || '').trim();
    if (!name || seen[name]) return;
    seen[name] = true;
    options.push(name);
  });

  return h('div', { className: 'wf-params-form' },
    h('div', { className: 'wf-params-row' },
      h('div', { className: 'wf-params-row-label' }, 'Variable'),
      h('select', {
        className: 'wf-params-input',
        value: selectedVar,
        onChange: function(e) { onParamChange('variable', e.target.value); }
      },
        h('option', { value: '' }, options.length === 0 ? 'No variables defined' : 'Pick a variable…'),
        options.map(function(name) {
          return h('option', { key: name, value: name }, name);
        })
      )
    ),
    h('div', { className: 'wf-params-row' },
      h('div', { className: 'wf-params-row-label' }, 'Source'),
      h('div', { className: 'wf-params-toggle' },
        h('button', {
          type: 'button',
          className: 'wf-params-toggle-btn' + (!isFromInput ? ' wf-params-toggle-btn-active' : ''),
          onClick: function() { onParamChange('source', 'false'); }
        }, 'Manual'),
        h('button', {
          type: 'button',
          className: 'wf-params-toggle-btn' + (isFromInput ? ' wf-params-toggle-btn-active' : ''),
          onClick: function() { onParamChange('source', 'true'); }
        }, 'From input')
      )
    ),
    h('div', { className: 'wf-params-row' },
      h('div', { className: 'wf-params-row-label' }, 'Mode'),
      h('div', null,
        h('select', {
          className: 'wf-params-input',
          value: selectedMode,
          onChange: function(e) { onParamChange('mode', e.target.value); }
        },
          modeOptions.map(function(opt) {
            return h('option', { key: opt.value, value: opt.value }, opt.label);
          })
        ),
        h('div', { style: { marginTop: 4, fontSize: 11, opacity: 0.65 } }, selectedModeHint)
      )
    ),
    !isFromInput
      ? h('div', { className: 'wf-params-row' },
          h('div', { className: 'wf-params-row-label' }, 'Value'),
          h(VariableAutocompleteInput, {
            multiline: true,
            rows: 4,
            placeholder: 'Type a value or @ to reference a variable',
            value: manualValue,
            variableNodes: variableNodes,
            onChange: function(next) { onParamChange('value', next); }
          })
        )
      : null
  );
}

module.exports = SetVariableSidebarEditor;
